import Vue from "vue";

const FABBI_CODE = 842462593637;

export const confirmModal = (
  message = "",
  title = "",
  okeTitle = "",
  cancelTitle = "",
  okVariant = "danger"
) => {
  const vm = new Vue({});
  return vm.$bvModal
    .msgBoxConfirm(message, {
      modalClass: "c-confirm-box-modal",
      dialogClass: "c-confirm-box-dialog",
      okOnly: true,
      title: title,
      cancelDisabled: true,
      size: "sm",
      buttonSize: "sm",
      okVariant: okVariant,
      okTitle: okeTitle,
      headerClass: "p-2 pl-3",
      footerClass: "p-2 border-top-0",
      hideHeaderClose: false,
      centered: true,
      cancelTitle: cancelTitle
    })
    .then(value => value)
    .catch(err => err);
};

export const confirm = (
  message = "",
  title = "",
  okeTitle = "",
  cancelTitle = "",
  okVariant = "danger"
) => {
  const vm = new Vue({});
  return vm.$bvModal
    .msgBoxConfirm(message, {
      modalClass: "c-confirm-box-modal",
      dialogClass: "c-confirm-box-dialog",
      okOnly: true,
      title: title,
      cancelDisabled: true,
      size: "sm",
      buttonSize: "sm",
      okVariant: okVariant,
      okTitle: okeTitle,
      headerClass: "p-2 pl-3",
      footerClass: "p-2 border-top-0",
      hideHeaderClose: false,
      centered: true,
      cancelTitle: cancelTitle
    })
    .then(value => value)
    .catch(err => err);
};

export const toast = (
  message,
  title = null,
  autoHideDelay = 2000,
  toaster = "b-toaster-top-center",
  variant = "primary"
) => {
  const vm = new Vue({});
  return vm.$bvToast.toast(message, {
    title,
    noCloseButton: false,
    autoHideDelay,
    appendToast: true,
    toaster,
    variant,
    noFade: false,
    solid: true
  });
};

export const detectURL = (text, linkTitle = null) => {
  let urlRegex = /(https?:\/\/[^\s]+)/g;
  if (!text) {
    return '';
  }
  return text.replace(urlRegex, function(url) {
    let title = linkTitle ? linkTitle : url
    return (
      `<a target="_blank" href="${url}">${title}</a>`
    );
  });
};

export const encodeFabbi = (ids) => {
  ids = ids.split(",");
  ids = ids.map(item => {
    return FABBI_CODE * parseInt(item) + 365
  })
  return ids.join(',');
}

export const decodeFabbi = (ids) => {
  ids = ids.split(',');
  ids = ids.map(item => {
    return (parseInt(item) - 365) / FABBI_CODE
  })
  let check = ids.every(item => item === parseInt(item))
  if (!check) {
    return false;
  }
  return ids.join(',');
}

export const formatNumber = (number) => {
  return Math.round(number * 100) / 100;
}
